import GradientBorderRadius from "@/ui/gradient-border-radius";
import Input from "@/ui/input";
import Avatar from "@/ui/avatar";
import { useToken } from "@/pages/token-v2/hooks/use-token";
import { Balance } from "@/ui/formats";
import { formatDecimalStringFloat } from "@/utils/currency";

const BalanceTokenInput = ({
  youSell,
  youSellPercentage,
  onYouSellChange,
  onYouSellPercentageChange,
}: {
  youSell: string;
  youSellPercentage: string;
  onYouSellChange: (v: string) => void;
  onYouSellPercentageChange: (v: string) => void;
}) => {
  const token = useToken();
  const tokenBalance = token?.balance ?? 0;

  const tokenIcon = token?.icon ?? "";

  return (
    <GradientBorderRadius radius="medium" gradient="default-border">
      <div className="px-[0.625rem] py-[0.4rem] flex justify-between">
        <div className="flex flex-col h-full gap-y-[0.275rem]">
          <span className="text-xs font-semibold">Sell</span>
          <Input
            activeWhenInputIsNotEmpty={false}
            value={youSell}
            gradient="none"
            hover="none"
            placeholder="0"
            gradientClassName="focus-within:before:bg-none"
            className="!h-[1.375rem]"
            onChange={(v) => {
              const formattedValue = formatDecimalStringFloat(
                v,
                true,
                false,
                8
              );

              onYouSellChange(formattedValue);
            }}
            leftSide={
              <div className="w-[1.375rem] h-full flex items-center justify-center">
                <Input.Accordion>
                  <Avatar size="token" source={tokenIcon} />
                </Input.Accordion>
              </div>
            }
          />
        </div>
        <div className="flex flex-col justify-between items-end gap-y-[0.275rem]">
          <span className="text-xs flex items-center gap-[0.188rem]">
            <span className="font-semibold">Balance:</span>{" "}
            <Balance value={Number(tokenBalance)} />
          </span>
          <div className="flex items-center gap-x-[0.3125rem]">
            <div className="w-[3.125rem] text-xs">
              <Input
                activeWhenInputIsNotEmpty={false}
                value={youSellPercentage}
                gradient="none"
                hover="none"
                placeholder="0"
                gradientClassName="focus-within:before:bg-none"
                className="!text-opacity-50 h-[1.375rem] text-end"
                onChange={(v) => {
                  if (Number(v) > 100 || Number(v) < 0) {
                    return;
                  }

                  const formattedValue = formatDecimalStringFloat(
                    v,
                    true,
                    false
                  );

                  onYouSellPercentageChange(formattedValue);
                }}
                rightSide={
                  <div className="h-[1.375rem]  flex items-center justify-center">
                    <Input.Accordion>%</Input.Accordion>
                  </div>
                }
              />
            </div>

            <span
              onClick={() => onYouSellPercentageChange("100")}
              className="text-xs cursor-pointer"
            >
              MAX
            </span>
          </div>
        </div>
      </div>
    </GradientBorderRadius>
  );
};

export default BalanceTokenInput;
